import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import IntroScreen from "@/pages/IntroScreen";
import GameScreen from "@/pages/GameScreen";
import EndScreen from "@/pages/EndScreen";
import CameraRoll from "@/pages/CameraRoll";
import useTTS from "@/hooks/useTTS";
import useAudio from "@/hooks/useAudio";

function App() {
    const [ttsEnabled, setTTSEnabled] = useState(false);
    const [hcMode, setHCMode] = useState(false);
    const [audioEnabled, setAudioEnabled] = useState(true);
    const [practiceMode, setPracticeMode] = useState(false);
    const tts = useTTS(ttsEnabled);
    const audio = useAudio(audioEnabled);

    useEffect(() => {
        document.body.classList.toggle("hc-mode", hcMode);
    }, [hcMode]);

    const common = {
        ttsEnabled, setTTSEnabled,
        hcMode, setHCMode,
        audioEnabled, setAudioEnabled,
        practiceMode, setPracticeMode,
        tts, audio,
    };

    return (
        <div className="App min-h-screen">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<IntroScreen {...common} />} />
                    <Route path="/play" element={<GameScreen {...common} />} />
                    <Route path="/end" element={<EndScreen {...common} />} />
                    <Route path="/roll" element={<CameraRoll {...common} />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
